/* sg-v : comportements des sections « reproduction fidèle ». Chargé une fois (garde window.__sgv). */
(function () {
  if (window.__sgv) return; window.__sgv = true;
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- carrousels : [data-sgv-car] > [data-sgv-track], [data-sgv-prev], [data-sgv-next], [data-sgv-prog], [data-sgv-num] ---- */
  function carrousel(c) {
    var t = c.querySelector('[data-sgv-track]'); if (!t) return;
    var prev = c.querySelector('[data-sgv-prev]'), next = c.querySelector('[data-sgv-next]');
    var barre = c.querySelector('[data-sgv-prog] > *'), num = c.querySelector('[data-sgv-num]');
    function pas() { var e = t.children[0]; if (!e) return t.clientWidth; var g = parseFloat(getComputedStyle(t).columnGap || getComputedStyle(t).gap) || 0; return e.getBoundingClientRect().width + g; }
    function maj() {
      var max = t.scrollWidth - t.clientWidth, x = t.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (barre) { var vis = t.clientWidth / Math.max(t.scrollWidth, 1); var w = Math.max(vis, .12) * 100; barre.style.width = w + '%'; barre.style.left = (max > 0 ? (x / max) * (100 - w) : 0) + '%'; }
      if (num) { var n = t.children.length, i = Math.min(n, Math.round(x / pas()) + 1); num.textContent = i + ' / ' + n; }
      var deborde = max > 4; $$('[data-sgv-seulsi]', c).forEach(function (el) { el.style.display = deborde ? '' : 'none'; });
    }
    if (prev) prev.addEventListener('click', function () { t.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { t.scrollBy({ left: pas(), behavior: 'smooth' }); });
    t.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
    window.addEventListener('resize', maj); maj();
  }

  /* ---- bloc d'achat : galerie + offres ---- */
  function achat(a) {
    var princ = a.querySelector('[data-sgv-princ]');
    $$('[data-sgv-vign]', a).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!princ) return;
        princ.src = b.getAttribute('data-src'); princ.srcset = b.getAttribute('data-srcset') || ''; princ.alt = b.getAttribute('data-alt') || '';
        $$('[data-sgv-vign]', a).forEach(function (x) { x.classList.toggle('is-actif', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });
    function majOffre() {
      var r = a.querySelector('input[name="id"]:checked'); if (!r) return;
      $$('.sgv-offre', a).forEach(function (l) { l.classList.toggle('is-actif', l.contains(r)); });
      $$('[data-sgv-prix]', a).forEach(function (e) { e.textContent = r.getAttribute('data-prix') || ''; });
      $$('[data-sgv-barre]', a).forEach(function (e) { var v = r.getAttribute('data-barre') || ''; e.textContent = v; e.style.display = v ? '' : 'none'; });
      $$('[data-sgv-eco]', a).forEach(function (e) { var v = r.getAttribute('data-eco') || ''; e.textContent = v; e.style.display = v ? '' : 'none'; });
    }
    $$('input[name="id"]', a).forEach(function (r) { r.addEventListener('change', majOffre); });
    majOffre();
  }

  /* ---- explorateur d'ingrédients ---- */
  function explorateur(x) {
    var boutons = $$('[data-sgv-exp-i]', x), cartes = $$('[data-sgv-exp-c]', x), barre = x.querySelector('[data-sgv-prog] > *');
    var prev = x.querySelector('[data-sgv-prev]'), next = x.querySelector('[data-sgv-next]'), i = 0, n = cartes.length;
    function voir(k) {
      i = (k + n) % n;
      boutons.forEach(function (b, j) { b.classList.toggle('is-actif', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      cartes.forEach(function (c, j) { c.classList.toggle('is-actif', j === i); });
      if (barre) { var w = 100 / Math.max(n, 1); barre.style.width = w + '%'; barre.style.left = (i * w) + '%'; }
      if (prev) prev.disabled = false; if (next) next.disabled = false;
    }
    boutons.forEach(function (b, j) { b.addEventListener('click', function () { voir(j); }); });
    if (prev) prev.addEventListener('click', function () { voir(i - 1); });
    if (next) next.addEventListener('click', function () { voir(i + 1); });
    if (n) voir(0);
  }

  /* ---- liste d'avis : tri + pages ---- */
  function liste(l) {
    var boite = l.querySelector('[data-sgv-avis]'); if (!boite) return;
    var items = $$('[data-sgv-av]', boite), parPage = parseInt(l.getAttribute('data-par-page'), 10) || 5, page = 1;
    var pages = l.querySelector('[data-sgv-pages]'), sel = l.querySelector('[data-sgv-tri]');
    function rendre() {
      var n = Math.max(1, Math.ceil(items.length / parPage));
      if (page > n) page = n;
      items.forEach(function (it, k) { boite.appendChild(it); it.hidden = !(k >= (page - 1) * parPage && k < page * parPage); });
      if (!pages) return;
      pages.innerHTML = ''; if (n < 2) return;
      for (var p = 1; p <= n; p++) { (function (p) { var b = document.createElement('button'); b.type = 'button'; b.textContent = p; if (p === page) b.className = 'is-actif'; b.setAttribute('aria-label', 'Page ' + p); b.addEventListener('click', function () { page = p; rendre(); }); pages.appendChild(b); })(p); }
    }
    if (sel) sel.addEventListener('change', function () {
      var v = sel.value;
      items.sort(function (a, b) {
        if (v === 'haut') return parseFloat(b.dataset.note) - parseFloat(a.dataset.note) || a.dataset.ordre - b.dataset.ordre;
        if (v === 'bas') return parseFloat(a.dataset.note) - parseFloat(b.dataset.note) || a.dataset.ordre - b.dataset.ordre;
        return a.dataset.ordre - b.dataset.ordre;
      });
      page = 1; rendre();
    });
    rendre();
  }

  function init(r) {
    $$('[data-sgv-car]', r).forEach(carrousel);
    $$('[data-sgv-achat]', r).forEach(achat);
    $$('[data-sgv-exp]', r).forEach(explorateur);
    $$('[data-sgv-liste]', r).forEach(liste);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
